const editUrl = (existingUrl, id, subscriberId) => {
  let url = existingUrl;
  if (id) {
    url = url.replace(':id', id);
  }
  if (subscriberId) {
    url = url.replace(':subscriberId', subscriberId.toString());
  }
  return url;
};

export default editUrl;
